import React from "react";
import TablaCargadeCodigos from "js/components/TablaCargadeCodigos";

function VentaCargadeCodigos(props) {
  return <TablaCargadeCodigos />;
}

export default VentaCargadeCodigos;
